var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPetaindia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "122 -123 400 400",
    style: {
      enableBackground: "new 122 -123 400 400"
    },
    xmlSpace: "preserve",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#3FB6DE",
    cx: 322,
    cy: 77,
    r: 200
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M242.2,5.2h-24.6L192.4,104h20.8l8.8-33.4h0.3l0,0c14.1,1.2,44.9,1.8,49.3-34.6C276,1,242.2,5.2,242.2,5.2z  M244.3,46.2c-7,7-17,4.4-17,4.4l2.6-11.1l3.8-14.7c1.5-0.3,11.7-1.2,14.4,1.2C251.6,28.9,249.3,41.5,244.3,46.2z M424.9,5.4 L379.8,104h23.2l7-16.1h21.1V104h20.5V5.4H424.9z M431.4,68.2h-12.6L431.1,40v-0.3v28.4H431.4z M327.3,6.6 c-17.9-6.2-32.6,8.5-42.8,22.3c-10,14.7-16.4,31.1-16.7,50.4c0.6,10.9,2.9,22.9,13.5,27.3c17.3,4.7,29.6-10.9,39-23.5 c0.9-1.8,2.6-3.5,2.6-5.6c-0.9-0.3-1.5-1.2-2.3-0.9c-2.1,2.9-3.8,5.9-6.5,8.8c-5.9,6.2-13.5,10.9-22,8.8 c-9.4-4.4-10-16.1-9.1-26.4c0.9-3.8,0.9-7.9,2.6-11.4l6.5-2.1c14.4-5,31.1-5.9,40.5-21.1c3.2-5.9,5.9-14.1,1.8-20.5 C332.6,9.8,329.9,7.5,327.3,6.6z M302.6,45.9c-19.4,6.7-14.4,3.8-14.4,3.8s14.7-46.6,29.6-41.1C333.1,14.2,322.3,39.2,302.6,45.9z  M402.1,26.9l5.6-21.1L345.8,6l-5.9,21.1h18.8l-19.9,77.1h22.6l20.5-77.1L402.1,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D7F4",
    d: "M400.3-21.5c0,0-2.6-3.8-32-10.6c0,0,10.3-5.9,8.5-21.1c0,0,14.4,1.8,13.2-5.9c0,0-5.9-15-19.6-15.8 c0,0-11.7-21.1-21.7-19.4c0,0-3.2,2.3,14.4,24.3c0,0-3.5,2.3-5.9,7.6c0,0-36.4-10-65.7-3.5c0,0-7.6-7.9-13.2,1.8 c0,0-3.2,7.3,5,10.9c0,0-1.8,3.5-2.9,11.7c0,0-5.6,1.2-10.9,7.6c0,0-7.9-2.1-10.9-1.2c0,0-8.2,5.6-16.1,19.6c0,0,0.3,3.8,2.9,3.8 c0,0,1.2,2.6,15.2-12.6c0,0,6.7,0.6,10.3-1.2c0,0,60.1-12,93.8,5.6c0,0,21.1,0.6,28.7,5.3C394.1-14.8,403.2-12.1,400.3-21.5z  M376.3-67c1.2,0,2.1,0.9,2.1,2.3c0,1.2-0.9,2.3-2.1,2.3s-2.1-0.9-2.1-2.3C373.9-65.8,375.1-67,376.3-67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M212.6,121l-15.5,81.8h-5.6L207,121H212.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M217.9,202.8l15.5-81.8h5.3l23.8,55.7c3.8,8.5,5.3,13.8,7,19.6h0.3c0.6-6.7,1.2-12.3,3.2-23.5l10-51.9h5.3 l-15.5,81.8h-5L244.6,148c-4.4-9.7-5.9-14.4-7.3-20.5l-0.3,0.3c-0.9,7.3-1.8,13.5-3.5,23.5l-9.7,51.6L217.9,202.8L217.9,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M309.1,121.9c5.9-0.9,12-1.5,19.1-1.5c14.1,0,24.9,4.4,30.2,12c2.9,4.1,5.6,10.9,5.6,20.2 c0,14.4-5.3,29.6-16.1,39c-9.4,8.2-21.4,11.7-35.8,11.7c-5.6,0-12,0-18.2-0.6L309.1,121.9z M300,198.1c4.7,0.6,9.4,0.6,12.3,0.6 c15.2,0,25.2-4.1,33.1-11.7c8.5-8.2,12.9-21.1,12.9-33.7c0-15.5-7-28.4-31.1-28.4c-4.1,0-10,0.3-13.5,1.2L300,198.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M392.1,121l-15.5,81.8H371l15.5-81.8H392.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M410.3,174.1l-15,28.7h-5.9l44-81.8h5.3l12.3,81.8h-5.3l-4.4-28.7L410.3,174.1L410.3,174.1z M440.8,169.4 l-4.1-27.3c-0.6-4.1-1.2-10-1.8-14.4h-0.3c-2.1,4.7-4.1,9.1-6.7,14.4l-14.7,27.6h27.6V169.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetaindia);
export default __webpack_public_path__ + "static/media/petaindia.b729fb3f818b807625ba164f296b3a94.svg";
export { ForwardRef as ReactComponent };